// extracted by mini-css-extract-plugin
export default {"jobcard":"Job_jobcard__GDLG7","job-card":"Job_job-card__Ku90b"};